import moment from "moment";
import { ContractCheckoutAPI } from "../api";
import { Invoice } from "./Invoice.class";
import { Receipt } from "./Receipt.class";

export class ContractCheckout {
  constructor(props) {
    this.objectId = props.objectId || "";
    this.date = props.date?.iso || moment().toISOString();
    this.dueDate = props.dueDate?.iso || moment().toISOString();

    this.areas = props.areas || [];
    this.isCloseContract = props.isCloseContract || false;

    this.checkOutTotalCost = props.checkOutTotalCost || 0;
    this.checkOutInvoices = props.checkOutInvoices?.map(i => {
      if ((i.isSent || true) && !i.isPaid && !props.checkOutTotalCost) {
        this.checkOutTotalCost += i.totalValue;
      }
      return {
        ...i
      };
    });
    if (this.checkOutInvoices && this.checkOutInvoices.length) {
      for (let checkOutInvoice of this.checkOutInvoices) {
        if (checkOutInvoice?.invoice?.receipts?.length) {
          checkOutInvoice.invoice.receipts = checkOutInvoice.invoice.receipts.map(r => new Receipt(r))
        }
      }
    }
    this.depositTotalCost = props.depositTotalCost || 0;
    this.depositInvoices = props.depositInvoices?.map(i => {
      if (i.isSent && i.isPaid && !props.depositTotalCost) {
        this.depositTotalCost += i.totalValue;
      }
      return {
        ...i
      };
    });
    if (this.depositInvoices && this.depositInvoices.length) {
      for (let depositInvoice of this.depositInvoices) {
        if (depositInvoice?.invoice?.receipts?.length) {
          depositInvoice.invoice.receipts = depositInvoice.invoice.receipts.map(r => new Receipt(r))
        }
        let creditNote = props.creditNotes && props.creditNotes.length && depositInvoice.invoice ? props.creditNotes.find(cn => cn.invoice && cn.invoice.objectId == depositInvoice.id) : null
        if (creditNote) depositInvoice.invoice.creditNote = creditNote
      }
    }
    this.unpaidTotalCost = props.unpaidTotalCost || 0;
    this.unpaidInvoices = props.unpaidInvoices?.map(i => {
      if (i.isSent && !i.isPaid && !props.unpaidTotalCost) {
        this.unpaidTotalCost += i.totalValue;
      }
      return {
        ...i
      };
    });
    if (this.unpaidInvoices && this.unpaidInvoices.length) {
      for (let unpaidInvoice of this.unpaidInvoices) {
        if (unpaidInvoice?.invoice?.receipts?.length) {
          unpaidInvoice.invoice.receipts = unpaidInvoice.invoice.receipts.map(r => new Receipt(r))
        }
      }
    }
    this.isForfeit = props.isForfeit || false
    this.forfeitNote = props.forfeitNote || ''
    this.modeForfeitSelect = props.modeForfeitSelect || 1
    this.forfeitCost = props.forfeitCost || 0
    this.creditNotes = props.creditNotes || []

    this.note = props.note || "";
    this.contract = props.contract || {};
    this.refundBankAccount = props.refundBankAccount || {};
    this.paymentProofFiles = props.paymentProofFiles || [];
    this.paymentMethod = props.paymentMethod == "cash" ? "cash" : "bank";
    this.payDate = props.payDate?.iso || props.payDate || null;
    this.paymentNote = props.paymentNote || '';
    this.isPaid = props.isPaid || false;
    this.summary = props.summary || [];
    this.customerData = props.customerData || {};
    this.expend = false;
    this.status = props.status || "";
    this.paymentMethod = props.paymentMethod || "";
    this.receivedBy = props.receivedBy || {};
    this.statusUpdatedAt = props?.statusUpdatedAt?.iso || null;
    this.invoicePayment = props.invoicePayment || null
    this.checkOutDate = props.checkOutDate?.iso || null;
    this.approveStatus = props.approveStatus || null
    this.isSendApproveTask = props.isSendApproveTask || null
    this.isNotClearDebt = props.isNotClearDebt || null
    this.imageFiles = props.imageFiles && props.imageFiles.length ? props.imageFiles : []
    this.market = props.market || null
  }
  get totalCost() {
    let depositTotalCost = this.depositTotalCost - (this.isForfeit ? parseFloat(this.forfeitCost) : 0)
    const totalCost = depositTotalCost - (this.checkOutTotalCost + this.unpaidTotalCost);
    return totalCost;
  }
  get totalCostAbs() {
    return Math.abs(this.totalCost);
  }
  get refundCost() {
    return this.totalCost > 0 ? Math.abs(this.totalCost) : 0;
  }
  get extraCost() {
    return this.totalCost < 0 ? Math.abs(this.totalCost) : 0;
  }
  get checkOutDateFormet() {
    return moment(this.checkOutDate).format("DD/MM/YYYY");
  }
  get statusUpdatedAtString() {
    return moment(this.statusUpdatedAt).format("DD/MM/YYYY");
  }
  get unpaidInvoicesTable() {
    return this.unpaidInvoices.map(i => {
      return new Invoice(i.invoice);
    });
  }
  get depositInvoicesTable() {
    return this.depositInvoices.map(i => {
      return new Invoice(i.invoice);
    });
  }
  get checkOutInvoicesTable() {
    return this.checkOutInvoices.map(i => {
      return new Invoice(i.invoice);
    });
  }

  static async getContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async getContractCheckoutData(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckoutData(payload);
    return new ContractCheckout(data.result);
  }
  static async successContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.successContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async createContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.createContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async sendContractCheckoutApproveTask(payload) {
    const { data } = await ContractCheckoutAPI.sendContractCheckoutApproveTask(payload);
    return new ContractCheckout(data.result);
  }
  static async cancelDraftContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.cancelDraftContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async updateContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.updateContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async clearDebtContractCheckout(contractCheckOutId) {
    const { data } = await ContractCheckoutAPI.clearDebtContractCheckout(contractCheckOutId);
    return new ContractCheckout(data.result);
  }
  get getReceivedBy() {
    let fullName = "";
    if (this.receivedBy) {
      if (this.receivedBy.firstName) fullName += this.receivedBy.firstName + " ";
      if (this.receivedBy.lastName) fullName += this.receivedBy.lastName;
    }
    return fullName;
  }
  static async getContractCheckoutsBetweenDateByMarket(payload) {
    const {
      data
    } = await ContractCheckoutAPI.getContractCheckoutsBetweenDateByMarket(
      payload
    );
    return data.result.map(
      c =>
        new ContractCheckout({
          ...c.contractCheckout,
          summary: c.summary
        })
    );
  }
  static async getContractCheckoutsStatusDateBetweenDateByMarket(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckoutsStatusDateBetweenDateByMarket(payload);
    return data.result.map(c => new ContractCheckout(c));
  }
  static async getContractCheckoutsByContract(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckoutsByContract(
      payload
    );
    return data.result.map(c => new ContractCheckout(c));
  }
  static async payContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.payContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async cancelContractCheckOutInvoicePayment(id) {
    const { data } = await ContractCheckoutAPI.cancelContractCheckOutInvoicePayment(id);
    return new ContractCheckout(data.result);
  }
  get paymentMethodString() {
    const paymentMethods = {
      1: "เงินสด",
      2: "โอนผ่านธนาคาร",
      3: "บัตรเดบิต/เครดิต",
      4: "Bill Payment",
      5: "หักจากเงินประกัน",
      6: "เช็คเงินสด",
      7: "QR Payment"
    };
    return paymentMethods[this.paymentMethod] || "";
  }
  get statusClass() {
    if (this.isSendApproveTask && this.approveStatus == 'pending') {
      return {
        css: "text-yellow-600 bg-yellow-50 border-yellow-500",
        text: "รอการอนุมัติ"
      }
    } else if (this.isSendApproveTask && this.approveStatus == 'rejected') {
      return {
        css: "text-red-600 bg-red-50 border-red-500",
        text: "ไม่อนุมัติ"
      }
    } else {
      if (this.status == "success") {
        return {
          color: "primary",
          css: "text-emerald-600 bg-emerald-50 border-emerald-500",
          text: "ย้ายออกแล้ว"
        }
      } else if (this.status == "pending") {
        return {
          color: "info",
          css: "text-picton-blue-500 bg-picton-blue-50 border-picton-blue-500",
          text: "รอการย้ายออก"
        }
      } else if (this.status == "draft") {
        return {
          color: "gray",
          css: "text-gray-400 bg-gray-50 border-gray-500",
          text: "แบบร่าง"
        }
      } else if (this.status == "rejected") {
        return {
          color: "error",
          css: "text-gray-500 bg-gray-50 border-gray-500",
          text: "ยกเลิก"
        }
      } else {
        return {
          color: "warning",
          css: "text-gray-500 bg-gray-50 border-gray-500",
          text: "ไม่มีสถานะ"
        }
      }
    }
  }
  get sumStatus() {
    if (this.approveStatus != "rejected" && (this.status == 'draft' && this.approveStatus == "draft")) {
      return "แบบร่าง"
    } else if (this.isSendApproveTask && this.approveStatus == "pending") {
      return "รออนุมัติ"
    } else if (this.isSendApproveTask && this.approveStatus == "rejected") {
      return "ไม่อนุมัติ"
    } else if (this.status == "rejected") {
      return "ยกเลิกแบบร่าง"
    } else if (this.invoicePayment) {
      return "รอตรวจสอบการโอนเงิน"
    } else if (this.isPaid) {
      return this.totalCost > 0
        ? "คืนเงินแล้ว"
        : this.totalCost < 0
          ? "ชำระเงินแล้ว"
          : "ไม่มีค่าใช้จ่าย"
    } else {
      return this.totalCost > 0
        ? "รอคืนเงิน"
        : this.totalCost < 0
          ? "รอชำระเงิน"
          : "ไม่มีค่าใช้จ่าย"

    }
  }
  get isPaidClass() {
    if (this.approveStatus != "rejected" && (this.status == 'draft' && this.approveStatus == "draft")) {
      return {
        color: "gray",
        css: "text-gray-400 bg-gray-50 border-gray-500",
        text: "แบบร่าง",
      }
    } else if (this.isSendApproveTask && this.approveStatus == "pending") {
      return {
        color: "warning",
        css: "text-yellow-500 bg-yellow-50 border-yellow-600",
        text: "รออนุมัติ",
      }
    } else if (this.isSendApproveTask && this.approveStatus == "rejected") {
      return {
        color: "gray",
        css: "text-gray-500 bg-gray-50 border-gray-500",
        text: "ไม่อนุมัติ",
      }
    } else if (this.status == "rejected") {
      return {
        color: "gray",
        css: "text-gray-500 bg-gray-50 border-gray-500",
        text: "ยกเลิกแบบร่าง",
      }
    } else if (this.invoicePayment) {
      return {
        color: "warning",
        css: "text-yellow-600 bg-yellow-50 border-yellow-500",
        text: "รอตรวจสอบการโอนเงิน",
      }
    } else if (this.isPaid) {
      return {
        color: "primary",
        css: "text-emerald-600 bg-emerald-50 border-emerald-500",
        text:
          this.totalCost > 0
            ? "คืนเงินแล้ว"
            : this.totalCost < 0
              ? "ชำระเงินแล้ว"
              : "ไม่มีค่าใช้จ่าย"
      }
    } else {
      return {
        color: this.totalCost >= 0 ? "info" : "error",
        css:
          this.totalCost >= 0
            ? "text-picton-blue-500 bg-picton-blue-50 border-picton-blue-500"
            : "text-red-500 bg-red-50 border-red-500",
        text:
          this.totalCost > 0
            ? "รอคืนเงิน"
            : this.totalCost < 0
              ? "รอชำระเงิน"
              : "ไม่มีค่าใช้จ่าย"
      }
    }
  }
  get areaSum() {
    return this.areas.reduce((acc, i) => acc + i.size, 0);
  }
  get areaNameListString() {
    return this.areas.map(i => i.name).join(", ");
  }
  get cssClass() {
    return {
      paymentTextClass: this.paymentTextClass,
      paymentBorderClass: this.paymentBorderClass,
      paymentBackgroundClass: this.paymentBackgroundClass
    };
  }
  static get status() {
    return this.status || "";
  }
}
